import { render } from "./BiometricAuthWidget.vue?vue&type=template&id=375d50b8&scoped=true"
import script from "./BiometricAuthWidget.vue?vue&type=script&lang=js"
export * from "./BiometricAuthWidget.vue?vue&type=script&lang=js"

import "./BiometricAuthWidget.vue?vue&type=style&index=0&id=375d50b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375d50b8"]])

export default __exports__